import {appIsEmbedded} from "./appIsEmbedded";

export function validateAuthentication (cookies, searchParams) {

    if(authenticationIsEnabled()) {
        const isEmbedded = appIsEmbedded();

        if(isEmbedded) {
            console.log("Validating embedding authentication...");
            return validateEmbeddingAuthentication(searchParams);

        } else {
            console.log("Validating basic authentication...");
            return validateBasicAuthentication(cookies);

        }
    }

    return true;
}






/* ***************************************************/
/*  PRIVATE FUNCTIONS */
/* ***************************************************/


/**
 * Validates embedding authentication (auth_token)
 *
 * @param searchParams
 * @returns {*|boolean}
 */
const validateEmbeddingAuthentication = (searchParams) => {
    const origin = getCurrentBrowserOrigin();

    if(origin) {
        const originIsAuthorized = domainIsAuthorized(origin);

        if(originIsAuthorized) {
            const authorized = searchParams.has("auth_token");

            if(!authorized) {
                console.error("Invalid token");
            }

            return authorized;
        }
    }

    return false;
}


/**
 * Validates basic authentication (admin's common username and password)
 *
 * @param cookies
 * @returns {boolean}
 */
const validateBasicAuthentication = (cookies) => {
    return cookies.jm_authorized === "true";
}

/**
 * Checks if domain is authorized to access the website
 *
 * @param domain
 * @returns {*}
 */
const domainIsAuthorized = (domain) => {

    const appDomain = new URL(window.location.href).origin;
    if(appDomain.includes(domain)) { // If domain is the same as app domain
        return true;

    } else {
        let authorized = false;
        const authorizedDomains = process.env.REACT_APP_EMBED_AUTHORIZED_DOMAINS.split(',');

        let index = 0;
        while(index < authorizedDomains.length && !authorized) {
            if (authorizedDomains[index].includes(domain))
                authorized = true;
            index++;
        }

        if (!authorized)
            console.error("Unauthorized domain: ", domain);

        return authorized;
    }
}

/**
 * Checks if authentication within app is enabled
 *
 * @returns {boolean}
 */
const authenticationIsEnabled = () => {
    return process.env.REACT_APP_AUTHENTICATION_ENABLED === "true";
}

/**
 * Gets current browser's origin
 *
 * @returns {null|string}
 */
const getCurrentBrowserOrigin = () => {
    const error = []

    try{
        console.log(`[Player] 1st attempt to find origin`)
        return window.parent.location.origin;
    } catch (e) {
        error.push(e);
    }

    try {
        console.log(`[Player] 2nd attempt to find origin`)
        if (window.location.ancestorOrigins) {
            return Array.from(window.location.ancestorOrigins)[0];
        }
    } catch (e) {
        error.push(e);
    }

    try{
        console.log(`[Player] 3th attempt to find origin`)
        const referrer = document.referrer;
        if(referrer) return new URL(referrer).origin;
    }catch(e){
        error.push(e);
    }

    console.warn("error when getting origin", error);

    return null;
}

